import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openRequestCallbackPopup } from '../../actions/requestCallback';
import { trackCallbackPopupOpen } from '../../analytics/trackCallback';
import { CallbackButton } from '../../components/CallbackButton';
import { getGaLabel } from '../../selectors/analytics';
import { selectCallbackButtonTextExperimentActive } from '../../selectors/experiments';
import { getAgentForCallback } from '../../selectors/newbuilding/agent';
import { TRequestCallbackOpener } from '../../types/requestCallback';

export interface ICallMeBackContainerProps {
  placeType: TRequestCallbackOpener;
}

export function CallMeBackContainer({ placeType }: ICallMeBackContainerProps) {
  const agent = useSelector(getAgentForCallback);
  const gaLabel = useSelector(getGaLabel);
  const isCallbackButtonTextExperimentActive = useSelector(selectCallbackButtonTextExperimentActive);
  const dispatch = useDispatch();

  const handleCallBackPopupOpen = React.useCallback(() => {
    trackCallbackPopupOpen(gaLabel, placeType);

    dispatch(openRequestCallbackPopup(placeType));
  }, [dispatch, gaLabel, placeType]);

  if (!agent) {
    return null;
  }

  // TODO: Занести выигравший text внутрь CallbackButton и удалить prop text в CD-190874.
  const buttonText = isCallbackButtonTextExperimentActive ? 'Заказ звонка' : 'Перезвоните мне';

  return <CallbackButton onClick={handleCallBackPopupOpen} text={buttonText} />;
}
